import { toast } from 'react-toastify';
import io from 'socket.io-client';

import restApi from '../Api/Rest.api'
import socketsApi from '../Api/Sockets.api';

import userService from './UserService';


/**
 * AuthService Implementation
 */
class AuthService {

    loggedIn: boolean
    /**
     * Constructs AuthService Instance
     */
    constructor() {
        //localStorage.clear();
        this.loggedIn = false
        const user = localStorage.getItem('user');

        if (user) {
            const _user = JSON.parse(user)
            const timestamp = _user.timestamp;
            if (timestamp != null && timestamp + 6 * 24 * 60 * 60 * 1000 < Date.now()) {
                localStorage.clear();
                this.loggedIn = false
            } else {
                this.loggedIn = true
                userService.init(_user)
            }
        } else {
            this.loggedIn = false

            // This line of code doesnt allow public routes to work

            // if (window.location.pathname != "/login" ) {
            //     window.location.replace("/login");
            // }
        }
    }


    async login(payload: any) {

        try {
            var user = await restApi.login(payload)
            console.log("This is my user " + user)
            // var socket = await socketsApi.connect(user)

            if(user.token.length > 0){
                this.loggedIn = true
                localStorage.setItem('user', JSON.stringify({...user, timestamp: Date.now()}));
            // window.location.replace("/loading");
                userService.init({user})
                console.log("This is user logged in")
                return user
            }else{
                // window.location.replace("/login")
                console.log("Wrong data!!")
                return user
            }

            // return socket
        } catch (error) {
            throw error
        }

    }

    async register(payload: any) {
        console.log("Payload", payload)
        var message = await restApi.register(payload)
            // localStorage.setItem('user', JSON.stringify(user));
        return message
    }

    async forgotPassword(payload: any) {
        try{
            console.log("Payload", payload)
        var message = await restApi.forgotPassword(payload)
        console.log("MESSAGE", message);
        return message
        }catch(error){
            throw error
        }
    }
    
    async verifyToken(payload: any) {
        console.log("Payload verify", payload);
        var message = await restApi.verifyToken(payload)
        console.log("MESSAGE", message);
        return message
    }

    async changePassword(payload: any, verificationToken: any) {
        console.log("Payload change", payload);
        var message = await restApi.changePassword(payload, verificationToken)
        console.log("MESSAGE", message);
        return message
    }

    logout() {
        this.loggedIn = false;
        localStorage.removeItem('user');
        localStorage.removeItem('URL');
    }

}

const authService = new AuthService()

export default authService